"use client"

import { useTranslations } from "next-intl"
import { useSourceStore } from "@/lib/source-store"
import { SOURCE_FILTER_ROW, sourceFilterPill } from "@/components/source-filter-pill"

export function EromeVersionTabs() {
  // Board labels are data in lib/source-store.ts, keyed here as
  // `erome_<boardId>`; .has() keeps any unknown board rendering its raw name.
  const tbn = useTranslations("boardNames")
  const source = useSourceStore((state) => state.getSource("erome"))
  const updateSource = useSourceStore((state) => state.updateSource)

  if (!source?.boards) return null

  const { available, selected } = source.boards
  const active = selected[0] || "all"

  return (
    <div className={SOURCE_FILTER_ROW}>
      {available.map((board) => {
        const isActive = active === board.id
        return (
          <button
            key={board.id}
            onClick={() => updateSource("erome", { boards: { ...source.boards!, selected: [board.id] } })}
            className={sourceFilterPill(isActive)}
          >
            {tbn.has(`erome_${board.id}`) ? tbn(`erome_${board.id}`) : board.name}
          </button>
        )
      })}
    </div>
  )
}
